import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import "./App.css";
import About from "./Component/About";
import Accessibility from "./Component/Accessibility";
import CartPage from "./Component/CartPage";
import { CartProvider } from "./Component/CartContext";
import CheckOut from "./Component/CheckOut";
import Contact from "./Component/Contact";
import Cookies from "./Component/Cookies";
import Delivery from "./Component/Delivery";
import Footer from "./Component/Footer";
import Faqs from "./Component/Faqs";
import Header from "./Component/Header";
import Main from "./Component/Main";
import PaySuccess from "./Component/SuccessPay";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import Returns from "./Component/Returns";
import Shop from "./Component/Shop";
import Terms from "./Component/Terms";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <CartProvider>
      <Router
        future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
      >
        <ScrollToTop />
        <div className="app-shell">
          <Header />
          <Routes>
            <Route path="/about" element={<About />} />
            <Route path="/accessibility" element={<Accessibility />} />
            <Route path="/shipping" element={<Delivery />} />
            <Route path="/" element={<Main />} />
            <Route path="/returns" element={<Returns />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/faqs" element={<Faqs />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/shopDetails/:id" element={<ProductDetail />} />
            <Route path="/cartpage" element={<CartPage />} />
            <Route path="/checkout" element={<CheckOut />} />
            <Route path="/paysuccess" element={<PaySuccess />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </CartProvider>
  );
}

export default App;
